<template>
<div class="qq">
  <div class="index_top fcolumn">
    <div class="top_logos frow">
      <div class="top_logo">
        <img class="logo_img" :src="require('@/assets/images/index_04.png')" mode="widthFix"/>
      </div>
      <div class="top_right">
        <div class="top_name">桃江农商银行</div>
        <div class="top_e">TAOJIANG RURAL COMMERCIAL BANK</div>
      </div>
    </div>
    <div class="top_title">{{title}}</div>
  </div>
  <div class="caogao" @click="saveData">
    <img class="caogao_img" :src="require('@/assets/images/save.png')" mode="widthFix"/>保存草稿
  </div>
  <!-- 基本信息 -->
  <div class="coll fcolumn">
    <div class="coll_li frow" @click="changeColl(1)">
      <div class="coll_title">基本信息</div>
      <img class="coll_img" :class="{'coll_active':coll1 == 1}" :src="require('@/assets/images/xiala.png')" mode="widthFix">
    </div>
    <div class="coll_content animated" :class="{'fblock':coll1 == 1,'fadeIn':coll1 == 1}">

      <div class="coll_box fcolumn">
        <div class="coll_stitle">1.身份证号<span>(*)</span></div>
        <div class="coll_input">
            <input class="signup_input w90" v-model="info.cid" maxlength="18" placeholder="请填写你的身份证号" @blur="getIdcode($event)" onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"/>
        </div>
        <span class="error" v-if="error.cid != ''">*{{error.cid}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">2.市/州<span>(*)</span></div>
        <div class="coll_select frow">
          <select class="signup_select w45 mr5" @change="selectP1" v-model="info.shi">
            <option value="" style="font-size:15px">请选择</option>
              <option v-for="item in provinces" :value="item.id" style="font-size:15px">{{item.name}}</option>
          </select>
          <select class="signup_select w45" @change="selectP2" v-model="info.qu">
              <option value="" style="font-size:15px">请选择</option>
              <option v-for="item in cityState" :value="item.id" style="font-size:15px">{{item.name}}</option>
          </select>
        </div>
        <span class="error" v-if="error.city != ''">*{{error.city}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">3.所在单位<span>(*)</span></div>
        <div class="coll_input">
            <input class="signup_input w90" v-model="info.unit" placeholder="请填写你的工作单位名称" >
        </div>
        <span class="error" v-if="error.unit != ''">*{{error.unit}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">4.姓名<span>(*)</span></div>
        <div class="coll_input">
            <input class="signup_input w90" v-model="info.name" placeholder="请填写你的姓名" >
        </div>
        <span class="error" v-if="error.name != ''">*{{error.name}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">5.籍贯<span>(*)</span></div>
        <div class="coll_select frow">
          <select class="signup_select w25 mr4" @change="selectP3" v-model="endprovinces">
              <option value="" style="font-size:15px">请选择</option>
              <option v-for="item in provinces2" :value="item.id" style="font-size:15px">{{item.name}}</option>
          </select>
          <select class="signup_select w30 mr4" @change="selectP4" v-model="endcity">
              <option value="" style="font-size:15px">请选择</option>
              <option v-for="item in cityState2" :value="item.id" style="font-size:15px">{{item.name}}</option>
          </select>
          <select class="signup_select w30" @change="selectP5" v-model="endaddress">
              <option value="" style="font-size:15px">请选择</option>
              <option v-for="item in address2" :value="item.id" style="font-size:15px">{{item.name}}</option>
          </select>
        </div>
        <span class="error" v-if="error.native_place != ''">*{{error.native_place}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">6.性别<span>(*)</span></div>
        <div class="coll_select frow">
          <select class="signup_select w95" v-model="info.gender">
              <option value="" style="font-size:15px">请选择</option>
              <option v-for="item in sex" :value="item.id" style="font-size:15px">{{item.value}}</option>
          </select>
        </div>
        <span class="error" v-if="error.gender != ''">*{{error.gender}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">7.出生年月<span>(*)</span></div>
        <div class="coll_input">
            <input class="signup_input w90" type="date" v-model="info.birthday" />
        </div>
        <span class="error" v-if="error.birthday != ''">*{{error.birthday}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">8.年龄<span>(*)</span></div>
        <div class="coll_input">
            <input class="signup_input w90" type="number" v-model="info.age" placeholder="请填写你的年龄" >
        </div>
        <span class="error" v-if="error.age != ''">*{{error.age}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">9.身高（cm）<span>(*)</span></div>
        <div class="coll_input">
            <input class="signup_input w90" type="number" v-model="info.height" placeholder="请填写纯数字，示例：158" >
        </div>
        <span class="error" v-if="error.height != ''">*{{error.height}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">10.政治面貌<span>(*)</span></div>
        <div class="coll_select frow ac">
          <select class="signup_select w30 mr4" v-model="info.politics_status">
              <option value="" style="font-size:15px">请选择</option>
              <option v-for="item in politics_status" :value="item.value" style="font-size:15px">{{item.value}}</option>
          </select>
          <input v-if="info.politics_status == '中共党员'" class="signup_input w55" v-model="info.join_party_date" placeholder="入党时间，示例：1997-03-11" >
        </div>
        <span class="error" v-if="info.politics_status == '中共党员' && error.join_party_date != ''">*{{error.join_party_date}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">11.参加工作时间<span>(*)</span></div>
        <div class="coll_input">
            <input class="signup_input w90" v-model="info.join_work_date" placeholder="请填写你参加工作的时间，示例：1997-03" >
        </div>
        <span class="error" v-if="error.join_work_date != ''">*{{error.join_work_date}}</span>
      </div>

    </div>
  </div>
  <!-- 全日制教育 -->
  <div class="coll fcolumn">
    <div class="coll_li frow" @click="changeColl(2)">
      <div class="coll_title">全日制教育</div>
      <img class="coll_img" :class="{'coll_active':coll2 == 1}" :src="require('@/assets/images/xiala.png')" mode="widthFix">
    </div>
    <div class="coll_content animated" :class="{'fblock':coll2 == 1,'fadeIn':coll2 == 1}">

      <div class="coll_box fcolumn">
        <div class="coll_stitle">12.学历<span>(*)</span></div>
        <div class="coll_select frow">
          <select class="signup_select w95" v-model="info.education">
              <option value="" style="font-size:15px">请选择</option>
              <option v-for="item in education" :value="item.value" style="font-size:15px">{{item.value}}</option>
          </select>
        </div>
        <span class="error" v-if="error.education != ''">*{{error.education}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">13.学位<span>(*)</span></div>
          <div class="coll_select frow">
          <select class="signup_select w95" v-model="info.degree">
              <option value="" style="font-size:15px">请选择</option>
              <option v-for="item in degree" :value="item.value" style="font-size:15px">{{item.value}}</option>
          </select>
        </div>
        <span class="error" v-if="error.degree != ''">*{{error.degree}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">14.毕业院校<span>(*)</span></div>
        <div class="coll_input">
            <input class="signup_input w90" v-model="info.graduate_school" placeholder="请填写你的学校，示例：湖南工程学院应用技术学院" >
        </div>
        <span class="error" v-if="error.graduate_school != ''">*{{error.graduate_school}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">15.专业<span>(*)</span></div>
        <div class="coll_input">
            <input class="signup_input w90" v-model="info.specialty" placeholder="请填写你的专业，示例：工商管理" >
        </div>
        <span class="error" v-if="error.specialty != ''">*{{error.specialty}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">16.是否应届毕业生<span>(*)</span></div>
          <div class="coll_select frow">
          <select class="signup_select w95" v-model="info.is_current">
              <option v-for="item in is_current" :value="item.id" style="font-size:15px">{{item.value}}</option>
          </select>
        </div>
        <span class="error" v-if="error.is_current != ''">*{{error.is_current}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">17.备案时间</div>
        <div class="coll_input">
            <input class="signup_input w90" type="date" v-model="info.filing_date" />
        </div>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">18.备注</div>
        <div class="coll_input">
            <input class="signup_input w90" v-model="info.remark" placeholder="备注" >
        </div>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">19.联系电话<span>(*)</span></div>
        <div class="coll_input">
            <input class="signup_input w90" type="number" v-model="info.phone" placeholder="请填写你的手机号码" >
        </div>
        <span class="error" v-if="error.phone != ''">*{{error.phone}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">20.报名岗位<span>(*)</span></div>
        <div class="coll_input frow">
          <template v-for="(item,index) in apply_post">
              <input class="in_ra" :value="index" v-model="info.apply_post" type="radio" :key="index" /><span class="radiotext">{{item}}</span>
          </template>
            
        </div>
        <span class="error" v-if="error.apply_post != ''">*{{error.apply_post}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">21.邮箱<span>(*)</span></div>
        <div class="coll_input">
            <input class="signup_input w90" v-model="info.email" placeholder="请填写你的邮箱地址，示例：36954@qq.com" >
        </div>
        <span class="error" v-if="error.email != ''">*{{error.email}}</span>
      </div>

    </div>
  </div>
  <!-- 报名资料 -->
  <div class="coll fcolumn">
    <div class="coll_li frow" @click="changeColl(3)">
      <div class="coll_title">报名资料</div>
      <img class="coll_img" :class="{'coll_active':coll3 == 1}" :src="require('@/assets/images/xiala.png')" mode="widthFix">
    </div>
    <div class="coll_content animated" :class="{'fblock':coll3 == 1,'fadeIn':coll3 == 1}">

    <div class="coll_box fcolumn">
      <div class="coll_stitle">22.证件照<span>(*)</span></div>
      <div class="imgs_box frow">
        <div class="imgs frow">
          <img class="add_img" :src="id_photo" :preview="id_photo" mode="widthFix">
          <img class="delete_img" :src="require('@/assets/images/delete.png')" mode="widthFix" @click="deleteImg(1)" v-if="id_photo != ''">
        </div>
      </div>
      <div class="file_box frow" v-if="id_photo == ''">
        <input class="in_file" @change="addImg($event)" type="file" name="scoreFile"><span class="file_span">上传</span>
        <div class="file_text w80">请上传红底照（一寸照）</div>
      </div>
      <div class="coll_shili frow">
        <div class="shili">一寸照示例图如图，点击查看大图</div>
        <img :src="require('@/assets/images/shili.jpg')" :preview="require('@/assets/images/shili.jpg')" mode="widthFix">
      </div>
      <span class="error" v-if="error.id_photo != ''">*{{error.id_photo}}</span>
    </div>

    <div class="coll_box fcolumn">
      <div class="coll_stitle">23.身份证<span>(*)</span></div>
      <div class="imgs_box frow">
        <div class="imgs frow">
          <img class="add_img" :src="card_front" :preview="card_front" mode="widthFix">
          <img class="delete_img" :src="require('@/assets/images/delete.png')" mode="widthFix" @click="deleteImg(2)" v-if="card_front != ''">
        </div>
      </div>
      <div class="file_box frow" v-if="card_front == ''">
        <input class="in_file" @change="addImg2($event)" type="file" name="scoreFile"><span class="file_span">上传</span>
        <div class="file_text w80">请上传身份证正面照片</div>
      </div>
      <div class="imgs_box frow">
        <div class="imgs frow">
          <img class="add_img" :src="card_back" :preview="card_back" mode="widthFix">
          <img class="delete_img" :src="require('@/assets/images/delete.png')" mode="widthFix" @click="deleteImg(3)" v-if="card_back != ''">
        </div>
      </div>
      <div class="file_box frow" v-if="card_back == ''">
        <input class="in_file" @change="addImg3($event)" type="file" name="scoreFile"><span class="file_span">上传</span>
        <div class="file_text w80">请上传身份证反面照片</div>
      </div>
      <span class="error" v-if="error.card_front != ''">*{{error.card_front}}</span>
    </div>

    <div class="coll_box fcolumn">
      <div class="coll_stitle">24.毕业证<span>(*)</span></div>
      <div class="imgs_box frow">
        <div class="imgs frow">
          <img class="add_img" :src="graduation_certificate" :preview="graduation_certificate" mode="widthFix">
          <img class="delete_img" :src="require('@/assets/images/delete.png')" mode="widthFix" @click="deleteImg(4)" v-if="graduation_certificate != ''">
        </div>
      </div>
      <div class="file_box frow" v-if="graduation_certificate == ''">
        <input class="in_file" @change="addImg4($event)" type="file" name="scoreFile"><span class="file_span">上传</span>
        <div class="file_text w80">请上传毕业证内页照片</div>
      </div>
      <span class="error" v-if="error.graduation_certificate != ''">*{{error.graduation_certificate}}</span>
    </div>

    <div class="coll_box fcolumn">
      <div class="coll_stitle">25.学位证<span>(*)</span></div>
      <div class="imgs_box frow">
        <div class="imgs frow">
          <img class="add_img" :src="diploma" :preview="diploma" mode="widthFix">
          <img class="delete_img" :src="require('@/assets/images/delete.png')" mode="widthFix" @click="deleteImg(5)" v-if="diploma != ''">
        </div>
      </div>
      <div class="file_box frow" v-if="diploma == ''">
        <input class="in_file" @change="addImg5($event)" type="file" name="scoreFile"><span class="file_span">上传</span>
        <div class="file_text w80">请上传学位证内页照片</div>
      </div>
      <span class="error" v-if="error.diploma != ''">*{{error.diploma}}</span>
    </div>

    <div class="coll_box fcolumn">
      <div class="coll_stitle">26.学籍证明（学信网电子注册备案表）<span>(*)</span></div>
      <div class="imgs_box frow">
        <div class="imgs frow">
          <img class="add_img" :src="student_status_certificate" :preview="student_status_certificate" mode="widthFix">
          <img class="delete_img" :src="require('@/assets/images/delete.png')" mode="widthFix" @click="deleteImg(6)" v-if="student_status_certificate != ''">
        </div>
      </div>
      <div class="file_box frow" v-if="student_status_certificate == ''">
        <input class="in_file" @change="addImg6($event)" type="file" name="scoreFile"><span class="file_span">上传</span>
        <div class="file_text w80">请上传学籍证明照片（应届毕业生请提供有效证件，例如学生证等）</div>
      </div>
      <span class="error" v-if="error.student_status_certificate != ''">*{{error.student_status_certificate}}</span>
    </div>

    <div class="coll_box fcolumn" style="margin-top:30px">
      <div class="coll_stitle">27.承诺书<span>(*)</span></div>
      <img class="add_img" :src="signature" :preview="signature" mode="widthFix">
      <!-- <div class="cns" @click="goto('/Signature')">桃江桃江农商银行承诺书</div> -->
      <div class="cns" @click="show2">诚信考试承诺书</div>
      <span class="error" v-if="error.signature != ''">*{{error.signature}}</span>
    </div>

    </div>
  </div>
  <!-- 家庭成员 -->
  <div class="coll fcolumn">
    <div class="coll_li frow" @click="changeColl(4)">
      <div class="coll_title">家庭成员</div>
      <img class="coll_img" :class="{'coll_active':coll4 == 1}" :src="require('@/assets/images/xiala.png')" mode="widthFix">
    </div>
    <div class="coll_content animated" :class="{'fblock':coll4 == 1,'fadeIn':coll4 == 1}">

      <div class="coll_box fcolumn">
        <div class="coll_stitle">28.父亲<span>(*)</span></div>
        <div class="coll_input frow">
            <input class="signup_input w35 mr5" v-model="info.fatherName" placeholder="姓名" >
            <input class="signup_input w45" v-model="info.fatherPhone" placeholder="手机号码" >
        </div>
        <span class="error" v-if="error.father != ''">*{{error.father}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">29.母亲<span>(*)</span></div>
        <div class="coll_input frow">
            <input class="signup_input w35 mr5" v-model="info.motherName" placeholder="姓名" >
            <input class="signup_input w45" v-model="info.motherPhone" placeholder="手机号码" >
        </div>
        <span class="error" v-if="error.mother != ''">*{{error.mother}}</span>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">30.兄弟姐妹</div>
        <div class="coll_input frow">
            <input class="signup_input w35 mr5" v-model="info.brother_sisterName" placeholder="姓名" >
            <input class="signup_input w45" type="number" v-model="info.brother_sisterPhone" placeholder="手机号码" >
        </div>
      </div>


      

    </div>
  </div>
  <!-- 相关银行工作经验（可不填） -->
  <div class="coll fcolumn">
    <div class="coll_li frow" @click="changeColl(5)">
      <div class="coll_title">相关银行工作经验（没有可不填）</div>
      <img class="coll_img" :class="{'coll_active':coll5 == 1}" :src="require('@/assets/images/xiala.png')" mode="widthFix">
    </div>
    <div class="coll_content animated" :class="{'fblock':coll5 == 1,'fadeIn':coll5 == 1}">

      <div class="coll_box fcolumn">
        <div class="coll_stitle">31.工作单位</div>
        <div class="coll_input frow">
            <input class="signup_input w90" v-model="info.work_unit" placeholder="填写单位名称" >
        </div>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">32.服务年限</div>
        <div class="coll_input frow">
            <input class="signup_input w90" v-model="info.seniority" placeholder="填写工作时间，示例：2020-11-01 - 2021-10-07" >
        </div>
      </div>
      
      <div class="coll_box fcolumn">
        <div class="coll_stitle">33.社保缴费记录</div>
        <div class="imgs_box frow">
          <div class="imgs frow">
            <img class="add_img" :src="social_security" :preview="social_security" mode="widthFix">
            <img class="delete_img" :src="require('@/assets/images/delete.png')" mode="widthFix" @click="deleteImg(7)" v-if="social_security != ''">
          </div>
        </div>
        <div class="file_box frow" v-if="social_security == ''">
          <input class="in_file" @change="addImg7($event)" type="file" name="scoreFile"><span class="file_span">上传</span>
          <div class="file_text w80">请上传社保缴费记录照片</div>
        </div>
      </div>

      <div class="coll_box fcolumn">
        <div class="coll_stitle">34.工作经历证明</div>
        <div class="imgs_box frow">
          <div class="imgs frow">
            <img class="add_img" :src="work_certify" :preview="work_certify" mode="widthFix">
            <img class="delete_img" :src="require('@/assets/images/delete.png')" mode="widthFix" @click="deleteImg(8)" v-if="work_certify != ''">
          </div>
        </div>
        <div class="file_box frow" v-if="work_certify == ''">
          <input class="in_file" @change="addImg8($event)" type="file" name="scoreFile"><span class="file_span">上传</span>
          <div class="file_text w80">请上传工作经历证明照片</div>
        </div>
      </div>

    </div>
  </div>
  <!-- 教育经验完善-->
  <div class="coll fcolumn">
    <div class="coll_li frow" @click="changeColl(6)">
      <div class="coll_title">教育经验完善</div>
      <img class="coll_img" :class="{'coll_active':coll6 == 1}" :src="require('@/assets/images/xiala.png')" mode="widthFix">
    </div>
    <div class="coll_content animated" :class="{'fblock':coll6 == 1,'fadeIn':coll6 == 1}">

      <div class="coll_box fcolumn">
        <div class="coll_stitle">35.教育经验完善情况<span>(*)</span></div>
        <div class="coll_input frow">
            <input class="signup_input w90" v-model="info.education_experience" placeholder="请完善教育经验，示例：小学-大学" >
        </div>
        <span class="error" v-if="error.education_experience != ''">*{{error.education_experience}}</span>
      </div>
    </div>
  </div>
  <div class="submit_btn" @click="showsa()">报名提交</div>
  <div class="index_bottom fcolumn">
    <div class="bottom_name">桃江农商银行</div>
    <div class="bottom_code">Copyright © 2022 桃江农商银行</div>
  </div>
  
  <div class="shadow" v-if="showShadow == 1" @touchmove.prevent></div>
  <div class="shadow_box" v-if="showShadow == 1">
    <input class="code_input w90" v-model="code" name="work" placeholder="输入短信验证码" @input="getDxcode($event)">
    <button class="tijiao" @click="getCode" :class="{'graycolor':canSub == true}" :disabled="subAgain">确认提交</button>
  </div>
  
  <template v-if="showSign == true">
    <div class="dialog">
        <vue-signature ref="signature1" w="300px" h="200px" style="border: #5B5A58 solid 1px;"></vue-signature>
        <div class="sign_btns">
            <div class="saveBtn" @click="save">保存</div>
            <div class="clearBtn" @click="clear">清除</div>
            <div class="cancleBtn" @click="cancleDia">取消</div>
        </div>
    </div>
  </template>
  <canvas id="canvas" width="600" height="400" style="position: absolute;top: -1000px;"></canvas>
  <div class="c-message" :class="message.status" v-show="message.show">
      <div class="c-message--main">
          <i class="c-message--icon" :class="message.type"></i>
          <div class="c-message--tip">{{message.text}}</div>
      </div>
  </div>

  <div class="shadow2" v-if="showShadow2 == 1" @touchmove.prevent></div>
  <img class="delete_img2" v-if="showShadow2 == 1" :src="require('@/assets/images/delete2.png')" mode="widthFix" @click="hide2">
  <div class="shadow_box2" v-if="showShadow2 == 1">
    <div v-html="promise_text"></div>
    <div class="frow ac mt20">
      <input class="in_ra" value="1" v-model="isread" type="radio" /><span class="radiotext">我已阅读</span>
    </div>
    <div class="qm">
      <div class="file_span2" @click="toSign">签名</div>
    </div>
  </div>
</div>
</template>

<script>
import vueSignature from 'vue-signature'
export default {
  name: 'SignUp',
  data () {
    return {
      promise_text:'',
      message: {
        show: '',
        type: '',
        status: '',
        text: '',
        time: '',
        timeout: ''
      },
      showSign:false,
      haveSign:false,
      msg: '',
      coll1:1,
      coll2:0,
      coll3:0,
      coll4:0,
      coll5:0,
      coll6:0,
      showShadow:0,
      showShadow2:0,
      isread:'',
      info:{
        city:'',//市州
        unit:'',//所在单位
        name:'',//姓名
        native_place:'',//籍贯
        cid:'',//身份证号
        gender:'',//性别
        birthday:'',//生日
        age:'',//年龄
        height:'',//身高
        politics_status:'',//政治面貌
        join_party_date:'',//入党时间
        join_work_date:'',//参加工作时间
        education:'',//学历
        degree:'',//学位
        graduate_school:'',//毕业院校
        specialty:'',//专业
        is_current:1,//是否应届毕业生
        filing_date:'',//备案时间
        remark:'',//备注
        phone:'',//联系电话
        apply_post:'',//报名岗位
        email:'',//邮箱
        father:'',//父亲
        fatherName:'',//父亲名字
        fatherPhone:'',//父亲电话
        mother:'',//母亲
        motherName:'',//母亲名字
        motherPhone:'',//母亲电话
        brother_sister:'',//兄弟姐妹
        brother_sisterPhone:'',//兄弟姐妹电话
        brother_sisterName:'',//兄弟姐妹名字
        work_unit:'',//工作单位
        seniority:'',//服务年限
        education_experience:'',//教育经验完善情况
        id_photo:'',//证件照
        card_front:'',//身份证正面
        card_back:'',//身份证反面
        graduation_certificate:'',//毕业证
        diploma:'',//学位证
        student_status_certificate:'',//学籍证明
        signature:'',//签名
        social_security:'',//社保缴费记录
        work_certify:'',//工作经历证明
        apply_id:'',//报名项目id
        shi:'',
        qu:'',
      },
      error:{
        city:'',//市州
        unit:'',//所在单位
        name:'',//姓名
        native_place:'',//籍贯
        cid:'',//身份证号
        gender:'',//性别
        birthday:'',//生日
        age:'',//年龄
        height:'',//身高
        politics_status:'',//政治面貌
        join_party_date:'',//入党时间
        join_work_date:'',//参加工作时间
        education:'',//学历
        degree:'',//学位
        graduate_school:'',//毕业院校
        specialty:'',//专业
        is_current:'',//是否应届毕业生
        filing_date:'',//备案时间
        remark:'',//备注
        phone:'',//联系电话
        apply_post:'',//报名岗位
        email:'',//邮箱
        father:'',//父亲
        fatherPhone:'',//父亲电话
        mother:'',//母亲
        motherPhone:'',//母亲电话
        brother_sister:'',//兄弟姐妹
        brother_sisterPhone:'',//兄弟姐妹电话
        work_unit:'',//工作单位
        seniority:'',//服务年限
        education_experience:'',//教育经验完善情况
        id_photo:'',//证件照
        card_front:'',//身份证正面
        card_back:'',//身份证反面
        graduation_certificate:'',//毕业证
        diploma:'',//学位证
        student_status_certificate:'',//学籍证明
        signature:'',//签名
        social_security:'',//社保缴费记录
        work_certify:'',//工作经历证明
        apply_id:'',//报名项目id
        code:''//短信验证码
      },
      sex:[
        {'id':1,'value':'男'},
        {'id':2,'value':'女'}
      ],//性别
      politics_status:[
        {'id':1,'value':'群众'},
        {'id':2,'value':'共青团员'},
        {'id':3,'value':'中共党员'},
        {'id':4,'value':'中共预备党员'},
        {'id':5,'value':'民革党员'},
        {'id':6,'value':'民盟盟员'},
        {'id':7,'value':'民建会员'},
        {'id':8,'value':'民进会员'},
        {'id':9,'value':'农工党党员'},
        {'id':10,'value':'致公党党员'},
        {'id':11,'value':'九三学社社员'},
        {'id':12,'value':'台盟盟员'},
        {'id':13,'value':'无党派人士'},
      ],//政治面貌
      education:[
        {'id':1,'value':'大专'},
        {'id':2,'value':'大学本科'},
        {'id':3,'value':'研究生'},
        {'id':4,'value':'博士'},
        {'id':5,'value':'博士后'}
      ],//学历
      degree:[
        {'id':1,'value':'学士'},
        {'id':2,'value':'硕士'},
        {'id':3,'value':'博士'}
      ],//学位
      is_current:[
        {'id':1,'value':'是'},
        {'id':2,'value':'否'},
      ],//是否应届毕业生
      url1:'',
      title:'',
      apply_post:[],//报名岗位
      provinces:[],//省份
      cityState:[],//市州
      provinces2:[],//省份
      cityState2:[],//市
      address2:[],//区
      endprovinces:'',
      endcity:'',
      endaddress:'',
      id_photo:'',//证件照
      card_front:'',//身份证正面
      card_back:'',//身份证反面
      graduation_certificate:'',//毕业证
      diploma:'',//学位证
      student_status_certificate:'',//学籍证明
      signature:'',//签名
      social_security:'',//社保缴费记录
      work_certify:'',//工作经历证明
      // sign_img:'',//电子签名照片
      timer:'',//计时器
      code:'',//短信验证码
      canSub:false,
      subAgain:false,
    }
  },
  methods:{
    //禁止点击
    touchStart(){
        event.preventDefault();//通知 Web 浏览器不要执行与事件关联的默认动作
    },
    getDxcode(e){
      this.code = e.target.value;
      if(this.code.length > 3){
        this.canSub = true;
      }
    },
    //获取保存信息
    getIdcode(e){
      console.log('失去焦点了');
      var idcard = e.target.value;
      var id = localStorage.getItem('id');
      var config = {};
      this.$request.get('/api/user/detail', {'cid':idcard,'apply_id':id},config, response => {
          if(response.data.code == 200){
              for(let i in response.data.data){
                if(this.info[i] == ''){
                  this.info[i] = response.data.data[i] != null ? response.data.data[i] : '';
                }
              }
              //获取市/州
              if(response.data.data['city']){
                var arr = response.data.data['city'].split(',');
                if(arr[0]){
                  this.getCityData(0);
                  this.info.shi = arr[0];
                }
                if(arr[1]){
                  this.getCityData(this.info.shi);
                  this.info.qu = arr[1];
                }
              }
              //获取籍贯
              if(response.data.data['native_place']){
                var arr = response.data.data['native_place'].split(',');
                if(arr[0]){
                  this.getCitysData(0,0);
                  this.endprovinces = arr[0];
                }
                if(arr[1]){
                  this.getCitysData(1,arr[0]);
                  this.endcity = arr[1];
                }
                if(arr[2]){
                  this.getCitysData(2,arr[1]);
                  this.endaddress = arr[2];
                }
              }
              //获取父母亲手机号
              if(response.data.data['father']){
                var arr = response.data.data['father'].split(',');
                if(arr[0]){
                  this.info.fatherName = arr[0];
                }
                if(arr[1]){
                  this.info.fatherPhone = arr[1];
                }
              }
              if(response.data.data['mother']){
                var arr = response.data.data['mother'].split(',');
                if(arr[0]){
                  this.info.motherName = arr[0];
                }
                if(arr[1]){
                  this.info.motherPhone = arr[1];
                }
              }
              if(response.data.data['brother_sister']){
                var arr = response.data.data['brother_sister'].split(',');
                if(arr[0]){
                  this.info.brother_sisterName = arr[0];
                }
                if(arr[1]){
                  this.info.brother_sisterPhone = arr[1];
                }
              }
              //获取图片
              if(response.data.data['id_photo']){
                this.id_photo = response.data.data['id_photo'];
              }
              if(response.data.data['card_front']){
                this.card_front = response.data.data['card_front'];
              }
              if(response.data.data['card_back']){
                this.card_back = response.data.data['card_back'];
              }
              if(response.data.data['graduation_certificate']){
                this.graduation_certificate = response.data.data['graduation_certificate'];
              }
              if(response.data.data['diploma']){
                this.diploma = response.data.data['diploma'];
              }
              if(response.data.data['student_status_certificate']){
                this.student_status_certificate = response.data.data['student_status_certificate'];
              }
              if(response.data.data['signature']){
                this.signature = response.data.data['signature'];
              }
              if(response.data.data['social_security']){
                this.social_security = response.data.data['social_security'];
              }
              if(response.data.data['work_certify']){
                this.work_certify = response.data.data['work_certify'];
              }
          }else if(response.data.code == 220){
            this.$request.Alert(this,response.data.message, 'warning', '2000');
          }
      }, error => {
          console.log(error)
      });
    },
    //提交手机验证码
    getCode(){
      this.subAgain = true;
      var str = /^(13[0-9]|14[0-9]|15[0-9]|18[0-9]|17[0-9]|19[0-9])\d{8}$/i;
      var flag = str.test(this.info.phone);
      if(flag){
        var config = {
            headers:{'Content-Type': 'multipart/form-data'}
        };
        var form_data = new FormData();
        for(let i in this.info){
          form_data.append(i,this.info[i]);
        }
        if(this.code.length > 3){
          this.$request.Alert(this,'正在提交', 'success', '1000');
          this.canSub = true;
          clearInterval(this.timer);
          var config1 = {};
          this.$request.post('/api/user/check-sms', {'phone':this.info.phone,'code':this.code},config1, response => {
              if(response.data.code == 200){
                this.$request.postFile('/api/user/create',form_data,config,response => {
                  this.subAgain = false;
                  if(response.data.code == 200){
                    this.$request.Alert(this,response.data.message, 'success', '2000');
                    this.hideSa();
                    setTimeout(()=>{
                      this.$router.push('/End');
                    },1000)
                  }else{
                    this.$request.Alert(this,response.data.message, 'warning', '2000');
                    this.hideSa();
                  }
                },error => {
                    console.log(error);
                })
              }else{
                this.hideSa();
                this.$request.Alert(this,response.data.message, 'warning', '2000');
              }
          }, error => {
              console.log(error)
          });
        }else{
          this.canSub = false;
          return;
        }
      }else{
        this.$request.Alert(this,'请输入正确的手机号', 'warning', '2000');
      }
    },
    //获取基本信息
    getBasicData(){
        var id = localStorage.getItem('id');
        var config = {};
        this.$request.get('/api/apply/get-data/' + id, {},config, response => {
            if(response.data.code == 200){
              this.title = response.data.data.name;
              this.apply_post = response.data.data.post;
              this.promise_text = response.data.data.promise_text;
              
                // for(let i in response.data.data.user_info){
                //     this.examInfo[i] = response.data.data.user_info[i];
                // }
            }else if(response.data.code == 250){
              this.$request.Alert(this,response.data.message, 'info', '2000');
              setTimeout(()=>{
                this.$router.push('./Index');
              },2000)
            }
        }, error => {
            console.log(error)
        });
    },
    //获取市州信息
    getCityData(id){
        var config = {};
        this.$request.get('/api/apply/get-region/' + id, {},config, response => {
            if(response.data.code == 200){
              if(id == 0){
                this.provinces = response.data.data;
              }else{
                this.cityState = response.data.data;
              }
              console.log(this.provinces,this.cityState);
            }
        }, error => {
            console.log(error)
        });
    },
    //获取省市区信息
    getCitysData(type,id){
        var access_token = localStorage.getItem('access_token');
        var config = {
            headers:{'X-Api-Key':access_token}
        };
        this.$request.get('/api/apply/get-region/' + id, {},config, response => {
            if(response.data.code == 200){
              if(type == 0){
                this.provinces2 = response.data.data;
              }else if(type == 1){
                this.cityState2 = response.data.data;
              }else if(type == 2){
                this.address2 = response.data.data;
              }
            }
        }, error => {
            console.log(error)
        });
    },
    //获取市州
    selectP1(e){
      this.info.shi = e.target.value;
      this.getCityData(e.target.value);
    },
    //选择市州
    selectP2(e){
      if(e.target.value != ''){
        this.info.qu = e.target.value;
      }else{
        this.info.qu = '';
      }
    },
    //获取市
    selectP3(e){
      this.address2 = [];
      this.cityState2 = [];
      this.getCitysData(1,e.target.value);
      if(e.target.value != ''){
        this.endprovinces = e.target.value;
      }else{
        this.endprovinces = '';
      }
    },
    //获取区
    selectP4(e){
      if(e.target.value != ''){
        this.endcity = e.target.value;
      }else{
        this.endcity = '';
      }
      this.getCitysData(2,e.target.value);
    },
    //选择区
    selectP5(e){
      if(e.target.value != ''){
        this.endaddress = e.target.value;
      }else{
        this.endaddress = '';
      }
      this.info.native_place = this.endprovinces + ',' + this.endcity + ',' + this.endaddress;
      console.log(this.info.native_place);
    },
    goto(page){
        this.$router.push(page);
    },
    showsa(){
      console.log(this.info);
      this.info.city = this.info.shi + ',' + this.info.qu;
      this.info.father = this.info.fatherName + ',' + this.info.fatherPhone;
      this.info.mother = this.info.motherName + ',' + this.info.motherPhone;
      this.info.brother_sister = this.info.brother_sisterName + ',' + this.info.brother_sisterPhone;
      this.info.apply_id = localStorage.getItem('id');
      this.error = {
        city:'',//市州
        unit:'',//所在单位
        name:'',//姓名
        native_place:'',//籍贯
        cid:'',//身份证号
        gender:'',//性别
        birthday:'',//生日
        age:'',//年龄
        height:'',//身高
        politics_status:'',//政治面貌
        join_party_date:'',//入党时间
        join_work_date:'',//参加工作时间
        education:'',//学历
        degree:'',//学位
        graduate_school:'',//毕业院校
        specialty:'',//专业
        is_current:'',//是否应届毕业生
        filing_date:'',//备案时间
        remark:'',//备注
        phone:'',//联系电话
        apply_post:'',//报名岗位
        email:'',//邮箱
        father:'',//父亲
        fatherPhone:'',//父亲电话
        mother:'',//母亲
        motherPhone:'',//母亲电话
        brother_sister:'',//兄弟姐妹
        brother_sisterPhone:'',//兄弟姐妹电话
        work_unit:'',//工作单位
        seniority:'',//服务年限
        education_experience:'',//教育经验完善情况
        id_photo:'',//证件照
        card_front:'',//身份证正面
        card_back:'',//身份证反面
        graduation_certificate:'',//毕业证
        diploma:'',//学位证
        student_status_certificate:'',//学籍证明
        signature:'',//签名
        social_security:'',//社保缴费记录
        work_certify:'',//工作经历证明
        apply_id:'',//报名项目id
        code:''//短信验证码
      };
     
      if(this.info.shi == '' || this.info.qu == ''){
        this.coll1 = 1;
        this.hideSa();
        this.error.city = '请填写市州';
        this.$request.Alert(this,'请填写市州', 'warning', '2000');
      }else if(this.info.unit == ''){
        this.coll1 = 1;
        this.hideSa();
        this.error.unit = '请填写所在单位';
        this.$request.Alert(this,'请填写所在单位', 'warning', '2000');
      }else if(this.info.name == ''){
        this.coll1 = 1;
        this.hideSa();
        this.error.name = '请填写姓名';
        this.$request.Alert(this,'请填写姓名', 'warning', '2000');
      }else if(this.info.native_place == ''){
        this.coll1 = 1;
        this.hideSa();
        this.error.native_place = '请填写籍贯';
        this.$request.Alert(this,'请填写籍贯', 'warning', '2000');
      }else if(this.info.cid == ''){

        this.coll1 = 1;
        this.hideSa();
        this.error.cid = '请填写身份证号';
        this.$request.Alert(this,'请填写身份证号', 'warning', '2000');
      }else if(this.info.cid.length != 18){
        this.coll1 = 1;
        this.hideSa();
        this.error.cid = '请填写正确的身份证号';
        this.$request.Alert(this,'请填写正确的身份证号', 'warning', '2000');
      }else if(this.info.gender == ''){
        this.coll1 = 1;
        this.hideSa();
        this.error.gender = '请选择性别';
        this.$request.Alert(this,'请选择性别', 'warning', '2000');
      }else if(this.info.birthday == ''){
        this.coll1 = 1;
        this.hideSa();
        this.error.birthday = '请填写出生年月';
        this.$request.Alert(this,'请填写出生年月', 'warning', '2000');
      }else if(this.info.age == ''){
        this.coll1 = 1;
        this.hideSa();
        this.error.age = '请填写年龄';
        this.$request.Alert(this,'请填写年龄', 'warning', '2000');
      }else if(this.info.height == ''){
        this.coll1 = 1;
        this.hideSa();
        this.error.height = '请填写身高';
        this.$request.Alert(this,'请填写身高', 'warning', '2000');
      }else if(this.info.politics_status == ''){
        this.coll1 = 1;
        this.hideSa();
        this.error.politics_status = '请填写政治面貌';
        this.$request.Alert(this,'请填写政治面貌', 'warning', '2000');
      }else if((this.info.politics_status == '中共党员') && (this.info.join_party_date == '')){
        this.coll1 = 1;
        this.hideSa();
        this.error.join_party_date = '请填写入党时间';
        this.$request.Alert(this,'请填写入党时间', 'warning', '2000');
      }else if(this.info.join_work_date == ''){
        this.coll1 = 1;
        this.hideSa();
        this.error.join_work_date = '请填写参加工作时间';
        this.$request.Alert(this,'请填写参加工作时间', 'warning', '2000');
      }else if(this.info.education == ''){
        this.coll2 = 1;
        this.hideSa();
        this.error.education = '请填写学历';
        this.$request.Alert(this,'请填写学历', 'warning', '2000');
      }else if(this.info.degree == ''){
        this.coll2 = 1;
        this.hideSa();
        this.error.degree = '请填写学位';
        this.$request.Alert(this,'请填写学位', 'warning', '2000');
      }else if(this.info.graduate_school == ''){
        this.coll2 = 1;
        this.hideSa();
        this.error.graduate_school = '请填写毕业院校';
        this.$request.Alert(this,'请填写毕业院校', 'warning', '2000');
      }else if(this.info.specialty == ''){
        this.coll2 = 1;
        this.hideSa();
        this.error.specialty = '请填写专业';
        this.$request.Alert(this,'请填写专业', 'warning', '2000');
      }else if(this.info.is_current == ''){
        this.coll2 = 1;
        this.hideSa();
        this.error.is_current = '请填写是否毕业';
        this.$request.Alert(this,'请填写是否毕业', 'warning', '2000');
      }else if(this.info.phone == ''){
        this.coll2 = 1;
        this.hideSa();
        this.error.phone = '请填写联系电话';
        this.$request.Alert(this,'请填写联系电话', 'warning', '2000');
      }else if(this.info.apply_post == ''){
        this.coll2 = 1;
        this.hideSa();
        this.error.apply_post = '请填写报名岗位';
        this.$request.Alert(this,'请填写报名岗位', 'warning', '2000');
      }else if(this.info.email == ''){
        this.coll2 = 1;
        this.hideSa();
        this.error.email = '请填写邮箱';
        this.$request.Alert(this,'请填写邮箱', 'warning', '2000');
      }else if(this.info.id_photo == ''){
        this.coll3 = 1;
        this.hideSa();
        this.error.id_photo = '请上传证件照';
        this.$request.Alert(this,'请上传证件照', 'warning', '2000');
      }else if((this.info.card_front == '') || (this.info.card_back == '')){
        this.coll3 = 1;
        this.hideSa();
        this.error.card_front = '请上传身份证正反面';
        this.$request.Alert(this,'请上传身份证正反面', 'warning', '2000');
      }else if(this.info.graduation_certificate == ''){
        this.coll3 = 1;
        this.hideSa();
        this.error.graduation_certificate = '请上传毕业证';
        this.$request.Alert(this,'请上传毕业证', 'warning', '2000');
      }else if(this.info.diploma == ''){
        this.coll3 = 1;
        this.hideSa();
        this.error.diploma = '请上传学位证';
        this.$request.Alert(this,'请上传学位证', 'warning', '2000');
      }else if(this.info.student_status_certificate == ''){
        this.coll3 = 1;
        this.hideSa();
        this.error.student_status_certificate = '请上传学籍证明';
        this.$request.Alert(this,'请上传学籍证明', 'warning', '2000');
      }else if(this.info.signature == ''){
        this.coll3 = 1;
        this.hideSa();
        this.error.signature = '请上传电子签名';
        this.$request.Alert(this,'请上传电子签名', 'warning', '2000');
      }else if(this.info.fatherName == '' || this.info.fatherPhone == ''){
        this.coll4 = 1;
        this.hideSa();
        this.error.father = '请填写父亲及其手机号';
        this.$request.Alert(this,'请填写父亲及其手机号', 'warning', '2000');
      }else if(this.info.motherName == '' || this.info.motherPhone == ''){
        this.coll4 = 1;
        this.hideSa();
        this.error.mother = '请填写母亲及其手机号';
        this.$request.Alert(this,'请填写母亲及其手机号', 'warning', '2000');
      }else if(this.info.education_experience == ''){
        this.coll6 = 1;
        this.hideSa();
        this.error.education_experience = '请填写教育经验完善情况';
        this.$request.Alert(this,'请填写教育经验完善情况', 'warning', '2000');
      }else{
        if(this.info.phone != ''){
          var config = {};
          this.$request.post('/api/user/send-sms', {'phone':this.info.phone},config, response => {
              if(response.data.code == 200){
                this.showShadow = 1;
                this.$request.Alert(this,'已发送验证码,请于1分钟内填写完毕', 'success', '10000');
                document.querySelector('body').setAttribute('style', 'overflow:hidden');
                this.timer = setInterval(this.hideSa.bind(this),120000);
              }else{
                this.$request.Alert(this,response.data.message, 'warning', '2000');
              }
          }, error => {
              console.log(error)
          });
        }else{
          this.coll2 = 1;
          this.error.phone = '请填写联系电话';
          this.$request.Alert(this,'请填写联系电话', 'warning', '2000');
        }
      }
    },
    hideSa(){
      this.showShadow = 0;
      document.querySelector('body').setAttribute('style', 'overflow:none');
      document.querySelector('body').setAttribute('style', 'background-color:#F0F1F3');
      this.code = '';
      this.canSub = false;
    },
    changeColl(index){
      if(index == 1){
        this.coll1 = !this.coll1;
      }else if(index == 2){
        this.coll2 = !this.coll2;
      }else if(index == 3){
        this.coll3 = !this.coll3;
      }else if(index == 4){
        this.coll4 = !this.coll4;
      }else if(index == 5){
        this.coll5 = !this.coll5;
      }else if(index == 6){
        this.coll6 = !this.coll6;
      }
    },
    changeRadio(){
    },
    //删除照片
    deleteImg(type){
      if(type == 1){//证件照
          this.info.id_photo = '';
          this.id_photo = '';
          // localStorage.removeItem('id_photo');
      }else if(type == 2){//身份证正面照
          this.info.card_front = '';
          this.card_front = '';
          // localStorage.removeItem('card_front');
      }else if(type == 3){//身份证反面照
          this.info.card_back = '';
          this.card_back = '';
          // localStorage.removeItem('card_back');
      }else if(type == 4){//毕业证
          this.info.graduation_certificate = '';
          this.graduation_certificate = '';
          // localStorage.removeItem('graduation_certificate');
      }else if(type == 5){//学位证
          this.info.diploma = '';
          this.diploma = '';
          // localStorage.removeItem('diploma');
      }else if(type == 6){//学籍证明
          this.info.student_status_certificate = '';
          this.student_status_certificate = '';
          // localStorage.removeItem('student_status_certificate');
      }else if(type == 7){//社保缴费记录
          this.info.social_security = '';
          this.social_security = '';
          // localStorage.removeItem('social_security');
      }else if(type == 8){//工作经历证明
          this.info.work_certify = '';
          this.work_certify = '';
          // localStorage.removeItem('work_certify');
      }
      
    },
    //证件照
    addImg(event){
      var file = event.target.files;
      // this.info.id_photo = file[0];
      this.fileAdd(1,file[0],(res)=>{
        this.info.id_photo = this.convertBase64UrlToBlob(res);
      });
    },
    //身份证正面
    addImg2(event){
      var file = event.target.files;
      // this.info.card_front = file[0];
      this.fileAdd(2,file[0],(res)=>{
        this.info.card_front = this.convertBase64UrlToBlob(res);
      });
    },
    //身份证反面
    addImg3(event){
      var file = event.target.files;
      // this.info.card_back = file[0];
      this.fileAdd(3,file[0],(res)=>{
        this.info.card_back = this.convertBase64UrlToBlob(res);
      });
    },
    //毕业证
    addImg4(event){
      var file = event.target.files;
      this.info.graduation_certificate = file[0];
      this.fileAdd(4,file[0],(res)=>{
        this.info.graduation_certificate = this.convertBase64UrlToBlob(res);
      });
    },
    //学位证
    addImg5(event){
      var file = event.target.files;
      this.info.diploma = file[0];
      this.fileAdd(5,file[0],(res)=>{
        this.info.diploma = this.convertBase64UrlToBlob(res);
      });
    },
    //学籍正面
    addImg6(event){
      var file = event.target.files;
      this.info.student_status_certificate = file[0];
      this.fileAdd(6,file[0],(res)=>{
        this.info.student_status_certificate = this.convertBase64UrlToBlob(res);
      });
    },
    //社保缴费记录
    addImg7(event){
      var file = event.target.files;
      this.info.social_security = file[0];
      this.fileAdd(7,file[0],(res)=>{
        this.info.social_security = this.convertBase64UrlToBlob(res);
      });
    },
    //工作经历证明
    addImg8(event){
      var file = event.target.files;
      this.info.work_certify = file[0];
      this.fileAdd(8,file[0],(res)=>{
        this.info.work_certify = this.convertBase64UrlToBlob(res);
      });
    },
    fileAdd(type,file,func) {
        //判断是否为图片文件
        if (file.type.indexOf('image') == -1) {
            this.$request.Alert(this,'请选择图片文件', 'warning', '2000');
        } else {
            let reader = new FileReader();
            let image = new Image();
            let _this = this;
            reader.readAsDataURL(file);
            reader.onload = function (evt) {
              // console.log('路径',evt.target.result);
                file.src = this.result;
                image.onload = function(){
                    let width = image.width;
                    let height = image.height;
                    file.width = width;
                    file.height = height;
                    if(file.size/1024 > 1025){
                      _this.$request.Alert(_this,'图片超过1M，请重新上传图片', 'warning', '2000');
                      return 
                    }else{
                      //页面上显示所选择的图片
                      if(type == 1){//证件照
                        _this.id_photo = file.src;
                      }else if(type == 2){//身份证正面照
                        _this.card_front = file.src;
                      }else if(type == 3){//身份证反面照
                        _this.card_back = file.src;
                      }else if(type == 4){//毕业证
                        _this.graduation_certificate = file.src;
                      }else if(type == 5){//学位证
                        _this.diploma = file.src;
                      }else if(type == 6){//学籍证明
                        _this.student_status_certificate = file.src;
                      }else if(type == 7){//社保缴费记录
                        _this.social_security = file.src;
                      }else if(type == 8){//工作经历证明
                        _this.work_certify = file.src;
                      }
                    }
                    
                };
                // console.log('原图',file);
                image.src= file.src; //页面上显示所选择的图片
                if(file.size/1024 > 1025){  //判断图片的大小，超过2M 进行压缩
                    // _this.$request.Alert(_this,'图片超过2M，请重新上传图片', 'warning', '2000');
                    return 
                }else{
                    // func(file)
                    func(file.src)
                }
            }
        }
    },
    //图片压缩
    imgCompress(path,obj,func){   //path是指上传的图片，obj是压缩的品质，越低越模糊
        let _this = this  //这里的this 是把vue的实例对象指向改变为_this
        var img = new Image();
        img.src = path.src;
        img.onload = function(){
            var that = this;  //这里的this 是把img的对象指向改变为that
            // 默认按比例压缩
            var w = that.width,
                h = that.height,
                scale = w / h;
            w = obj.width || w;
            h = obj.height || (w / scale);
            var quality = 0.7;  // 默认图片质量为0.7
            //生成canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            // 创建属性节点
            var anw = document.createAttribute("width");
            anw.nodeValue = w;
            var anh = document.createAttribute("height");
            anh.nodeValue = h;
            canvas.setAttributeNode(anw);
            canvas.setAttributeNode(anh);
            ctx.drawImage(that, 0, 0, w, h);
            // 图像质量
            if(obj.quality && obj.quality <= 1 && obj.quality > 0){
                quality = obj.quality;
            }
            // quality值越小，所绘制出的图像越模糊
            var base64 = canvas.toDataURL('image/jpeg', quality);
            // 回调函数返回base64的值
            var urlFile = _this.convertBase64UrlToBlob(base64)  //这个地方的处理是为了把压缩的base64转化为对象，获得压缩后图片的大小size，方便对压缩后的图片再次进行判断；
            if(urlFile.size/1024 > 1025){
              _this.$request.Alert(_this,'图片过大，请重新上传图片', 'warning', '2000');
            }else{
                func(urlFile)
            }
            // func(urlFile)
        }
    },
    //将base64码转化为file（Blob）
    //此处函数对压缩后的base64经过处理返回{size: "", type: ""}
    convertBase64UrlToBlob(urlData){
        var arr = urlData.split(','),mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {type:mime});
    },

    show2(){
      this.showShadow2 = 1;
      document.querySelector('body').setAttribute('style', 'overflow:hidden');
    },
    hide2(){
      this.showShadow2 = 0;
      document.querySelector('body').setAttribute('style', 'overflow:none');
      document.querySelector('body').setAttribute('style', 'background-color:#F0F1F3')
    },
    toSign(){
      if(this.isread == 1){
        this.showSign = true;
        this.hide2();
      }else{
        this.$request.Alert(this,'请选择已阅读', 'warning', '2000');
      }
    },
    //保存电子签名
    save(){
      this.haveSign = false;
      var _this = this;
      var jpeg = _this.$refs.signature1.save('image/jpeg');
      // console.log('jpeg',jpeg);
      this.signature = jpeg;
      // localStorage.setItem('signature',this.signature);
      let param = new FormData();
      var data_blob = this.dataURItoBlob(jpeg);
      this.info.signature = data_blob;
      console.log('blob',data_blob);
      param.append('pic_passport',data_blob,'sss.jpg');
      this.cancleDia();

      var img = new Image();
      img.onload = function () {
          var context = canvas.getContext('2d');
          // 图片绘制
          context.drawImage(img, 0, 0, 600, 400);
          // 然后获取中间100*100区域数据
          var imageData = context.getImageData(0, 0, 600, 400);
          var length = imageData.data.length;
          for (var index = 0; index < length; index += 4) {
              var r = imageData.data[index];
              var g = imageData.data[index + 1];
              var b = imageData.data[index + 2];
              // 判断是否存在写字
              if(r == 0 && g == 0 && b == 0){
                  _this.haveSign = true;
                  break;
              }
            //   console.log( r,g,b);
            }
        };
        img.src = this.signature;
        console.log('写字',this.haveSign,_this.haveSign);
        // 调用
        let file = this.dataURLtoFile(this.signature,'aaa.jpg');
        // localStorage.setItem('Signature',file);
        this.savesign(file);
    },
     //毕业证书
    savesign(file){

    },
    //base64转化为file
    dataURLtoFile(dataurl, filename) {
        let arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    },
    dataURItoBlob(base64Data){
      var byteString;
      if (base64Data.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(base64Data.split(',')[1]);
      else
        byteString = unescape(base64Data.split(',')[1]);
      var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], {type:mimeString});
    },
    clear(){
        var _this = this;
        _this.$refs.signature1.clear();
    },
    cancleDia(){
        this.showSign = false;
    },
    saveData(){
      var config = {
        headers:{'Content-Type': 'multipart/form-data'}
      };
      this.info.city = this.info.shi + ',' + this.info.qu;
      this.info.father = this.info.fatherName + ',' + this.info.fatherPhone;
      this.info.mother = this.info.motherName + ',' + this.info.motherPhone;
      this.info.brother_sister = this.info.brother_sisterName + ',' + this.info.brother_sisterPhone;
      var form_data = new FormData();
      for(let i in this.info){
        form_data.append(i,this.info[i]);
      }
      this.$request.postFile('/api/user/draft',form_data,config,response => {
        if(response.data.code == 200){
          this.$request.Alert(this,'数据已保存', 'success', '2000');
        }else{
          this.$request.Alert(this,response.data.message, 'warning', '2000');
        }
      },error => {
          console.log(error);
      })
    }
  },
  mounted() {
    document.querySelector('body').setAttribute('style', 'background-color:#F0F1F3')
  },
  created(){
    localStorage.setItem('id',this.$route.query.id);
    this.info.apply_id = localStorage.getItem('id') ? localStorage.getItem('id') : this.$route.query.id;
    this.getBasicData();
    this.getCityData(0);
    this.getCitysData(0,0);
  },
   components:{
    vueSignature
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .caogao{
    width:60px;
    height:60px;
    border-radius:5px;
    border:1px solid #94070A;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size:12px;
    color:#94070A;
    position: fixed;
    right:10px;
    z-index:3;
    background: white;
    top:40%;
  }
  .caogao_img{
    width:40px;
  }
    button{
      border:none;
    }
  .index_top{
    width:100%;
    background: #940709;
    height:150px;
  }
  .top_logos{
    padding:10px 5%;
  }
  .top_logo{
    width:100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo_img{
    width:69px;
    height:69px;
  }
  .top_right{
    color:white;
  }
  .top_name{
    height:40px;
    font-weight: bold;
    font-size:25px;
    line-height:40px;
    letter-spacing:10px;
  }
  .top_e{
    height:40px;
    font-size:10px;
    line-height:40px;
    margin-top:-5px;
  }
  .top_title{
    height:50px;
    background: #940709;
    color:white;
    font-weight: bold;
    font-size:23px;
    text-align: center;
    line-height:50px;
  }
  .coll{
    width:90%;
    padding:10px 2%;
    margin:10px auto;
    background:white;
    border-radius:5px;
  }
  .coll_li{
    height:30px;
    align-items: center;
    position: relative;
    z-index:2;
  }
  .coll_title{
    width:90%;
    font-size:18px;
  }
  .coll_img{
    width:20px;
    height:20px;
    transition: all 0.5s;
  }
  .coll_active{
		transform: rotate(-180deg);
	}
  .coll_content{
    display: flex;
    flex-direction: column;
    color:#666666;
    font-size:15px;
    display: none;
  }
  .fblock{
    display: block;
  }
  .coll_box{
    margin-top:20px;
  }
  .coll_stitle span{
    color:#FE0000;
    margin-left:5px;
  }
  .coll_select{
    margin-top:10px;
  }
  .coll_input{
    margin-top:10px;
  }
  .file_box{
    margin-top:10px;
  }
  .file_text{
    height:30px;
    line-height:30px;
    /* border:1px solid #D4DADD; */
    color:#666666;
    /* background:#F3F3F3; */
    padding-left:10px;
    font-size:14px;
  }
  .signup_select{
    height:30px;
    line-height:30px;
    border:1px solid #D4DADD;
    color:#666666;
    background:#F3F3F3;
    padding-left:10px;
  }
  .signup_input{
    height:30px;
    line-height:30px;
    border:1px solid #D4DADD;
    color:#666666;
    background:#F3F3F3;
    padding-left:10px;
  }
  .in_ra{
    margin-right:5px;
  }
  .radiotext{
    margin-right:20px;
  }
  .in_file{
      opacity: 0;
      filter: alpha(opacity=0);
      cursor: pointer;
      height: 30px;
      width:50px;
      position: relative;
      margin-right:-50px;
  }
  .file_span{
      font-size: 15px;
      width:50px;
      height:30px;
      color:#94070A;
      line-height:30px;
      text-align: center;
      border:1px solid #94070A;
  }
  .shili{
    min-width:30px;
    height:30px;
    line-height:30px;
    color:#94070A;
    font-size:13px;
    margin-right:10px;
  }
  .coll_shili{
    width:100%;
    min-height:80px;
    background:#F0F1F3;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top:10px;
  }
  .coll_shili img{
    width:50px;
  }
  .submit_btn{
    width:92%;
    margin:20px auto;
    background:#940709;
    color:white;
    text-align:center;
    height:45px;
    line-height:45px;
    font-size:16px;
  }
  .index_bottom{
    width:100%;
    height:40px;
    border-top:5px solid white;
    color:#999999;
    font-size:12px;
    padding:10px 0;
  }
  .bottom_name{
    height:20px;
    line-height:20px;
    text-align: center;
    font-weight: bold;
  }
  .bottom_code{
    height:25px;
    line-height:25px;
    text-align: center;
  }
  .cns{
    color:#2172DF;
    height:25px;
    line-height:25px;
    text-decoration:underline;
    border-color:#2172DF;
    margin-top:10px;
  }
  .imgs_box{
    margin:10px 0;
  }
  .imgs{
    align-items: flex-start ;
  }
  .add_img{
    width:60px;
  }
  .delete_img{
    width:15px;
    height:15px;
    position: relative;
    top:-5px;
  }
  
  .error{
      text-align: left;
      margin-top:10px;
      color:#EA0004;
      font-size:11px;
  }
  .shadow{
		width:100%;
		height:100%;
		position: fixed;
		top:0;
		z-index:1;
		background: rgba(0,0,0,0.7);
	}
  .shadow_box{
		width:80%;
    height:200px;
    border-radius:5px;
		/* background: white; */
    position: fixed;
    z-index:2;
    top:30%;
    left:10%;
    display: flex;
    flex-direction: column;
    align-items: center;
	}
  .code_input{
    width:80%;
    height:40px;
    line-height:40px;
    background:white;
    padding-left:10px;
    border:none;
  }
  .tijiao{
    width:120px;
    height:40px;
    line-height:40px;
    background: #AEADAD;
    color:black;
    font-size:15px;
    text-align: center;
    border-radius:5px;
    padding: 0 10px;
    margin-top:20px;
  }
  .graycolor{
    background: #94070A;
    color:white;
  }
  .dialog{
      width:100%;
      height:100%;
      background: rgba(0,0,0,0.6);
      z-index: 100;
      top:0;
      position: fixed;
      justify-content: center;
      align-items: center;
      display: flex;
      flex-direction: column;
  }
  .sign_btns{
    display: flex;
    flex-direction: row;
    margin-top:20px;
    justify-content: center;
    text-align: center;
  }
  .saveBtn{
      width:80px;
      height:30px;
      line-height:30px;
      color:white;
      background:#4367FD;
      border-radius:5px;
      font-size:13px;
  }
  .clearBtn{
      width:80px;
      height:30px;
      line-height:30px;
      color:white;
      background:#DA3807;
      border-radius:5px;
      font-size:13px;
      margin:0 10px;
  }
  .cancleBtn{
    width:80px;
    height:30px;
    line-height:30px;
    color:white;
    background:gray;
    border-radius:5px;
    font-size:13px;
  }
  .shadow2{
		width:100%;
		height:100%;
		position: fixed;
		top:0;
		z-index:4;
		background: rgba(0,0,0,0.7);
	}
  .shadow_box2{
		width:80%;
    max-height:500px;
    border-radius:5px;
    position: fixed;
    z-index:5;
    top:10%;
    margin-left: 8%;
    display: flex;
    flex-direction: column;
    background:white;
    overflow-y: auto;
    padding: 1% 2%;
	}
  .delete_img2{
    width:15px;
    height:15px;
    position: fixed;
    top:11%;
    z-index:6;
    margin-left:86%;
  }
  .qm{
    display: flex;
    justify-content: flex-end;

  }
  .file_span2{
      font-size: 15px;
      width:50px;
      height:30px;
      color:#94070A;
      line-height:30px;
      text-align: center;
      border:1px solid #94070A;
      padding:2px 5px;
      margin:10px 10px 10px 0;
      cursor: pointer;
  }
  .title{
      height:30px;
      line-height:30px;
      text-align: center;
      font-size:20px;
      font-weight: bold;
      margin-bottom:20px;
  }
  .scontent{
      font-size:15px;
      text-indent: 2em;
      color:#44444F;
      line-height:25px;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  @media screen and (min-width: 415px){
    .shadow2{
      width:500px;
      height:100%;
      position: fixed;
      top:0;
      z-index:4;
      background: rgba(0,0,0,0.7);
    }
    .shadow_box2{
      width:400px;
      min-height:200px;
      border-radius:5px;
      position: fixed;
      z-index:5;
      background:white;
      top:20%;
      margin-left: 50px;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      padding: 10px;
    }
    .dialog{
      width:500px;
      height:100%;
      background: rgba(0,0,0,0.6);
      z-index: 100;
      top:0;
      position: fixed;
      justify-content: center;
      align-items: center;
      display: flex;
      flex-direction: column;
    }
    .delete_img2{
      width:20px;
      height:20px;
      position: fixed;
      top:21%;
      z-index:6;
      margin-left: 443px;
    }
    .shadow{
      width:500px;
      height:100%;
      position: fixed;
      top:0;
      z-index:1;
      background: rgba(0,0,0,0.7);
    }
    .shadow_box{
      width:400px;
      height:200px;
      border-radius:5px;
      position: fixed;
      z-index:2;
      top:30%;
      margin-left: 550px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .caogao{
      width:60px;
      height:60px;
      border-radius:5px;
      border:1px solid #94070A;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size:12px;
      color:#94070A;
      position: fixed;
      right:38%;
      z-index:3;
      background: white;
      top:40%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SignUp.vue